export const PATH = Object.freeze({
  MAIN_PAGE: '/',
  SEARCH_PAGE: '/search',
  GENRE_PAGE: '/genre',
  NOT_FOUND: '*',
});

export const NAVBAR_TITLE = Object.freeze({
  HOME: 'Home',
  SEARCH: 'Search',
  CATEGORY: 'Category',
});

export const SECTION_TITLE = Object.freeze({
  TOP10: 'TOP10 인기 영화',
  DAY_POPULAR: '일간 인기 영화',
  WEEK_POPULAR: '주간 인기 영화',
  TOP_RATED: '역대 인기 영화',
  NOW_PLAYING: '현재 상영중인 영화',
});

export const GENRE_TITLE = Object.freeze({
  VIEW_ALL: '전체보기',
});

export const EMPTY_MESSAGE = Object.freeze({
  MOVIE_NOT_FOUND: 'movie not found',
  SEARCH_AGAIN: 'search again',
});

export const SEARCH_MESSAGE = Object.freeze({
  RESULT: '로 검색한 결과입니다.',
  RECOMMEND: '이런 영화는 어떠신가요?',
});

export const VARIOUS_NUMBERS = Object.freeze({
  PAGE_AMOUNT: 20,
  TAGS_LIMIT: 5,
  STAR_NUMBER: 5,
  TIMEOUT_LIMIT: 1000,
});

export const MODAL = Object.freeze({
  VIDEO_WIDTH: 600,
  VIDEO_HEIGHT: 300,
  NOT_OVERVIEW: '줄거리가 제공되지 않습니다.',
  NOT_CASTS: '출연진이 제공되지 않습니다.',
});

export const MOVIECARD_MESSAGE = Object.freeze({
  NO_OVERVIEW: '줄거리 정보없음.',
  ALT_POSTER: '포스터',
});
